<template>
  <div class="nav-view" v-show="menuData.length > 0" ref="menuWrapper">
    <ul class="menu-list" v-show="menuData.length > 0">
      <li class="menu-item" v-for="(item,index) in menuData" v-show="!((appCont==7||appCont==0)&&item&&item.categoryId==35)" :class="{'active':index == clickIndex,'center':item.categoryId == newGoodsTabId}" :key="index" @click="selectMenu($event,index,item.categoryId,item.categoryName)" ref="menuItem" >{{item && item.categoryName}}</li>
    </ul>
  </div>
</template>

<script>
import BScroll from 'better-scroll'
import { createNamespacedHelpers } from 'vuex'
import Scroll from '@/pages/commodity/components/Scroll.vue'

const { mapState, mapActions } = createNamespacedHelpers('categoryNav')
export default {
  components: {
    Scroll
  },
  props: ['pageId'],
  data() {
    return {
      clickIndex: 0
    }
  },
  computed: {
    ...mapState({
      appCont: state => state.appCont, // 菜单数据
      menuData: state => state.menuData, // 菜单数据
      newGoodsTabId: state => state.newGoodsTabId // 新品
    }),
    // 记录选中类目的id
    categoryId: {
      get() {
        return this.$store.state.categoryNav.categoryId
      },
      set(val) {
        this.$store.commit('categoryNav/SETCATEGORYID', val)
      }
    }
  },
  created() {
    this.queryCategoryName()
    this.checkUserType()
  },
  mounted() {
    this.$nextTick(() => {
      // eslint-disable-next-line no-unused-vars
      const scroll = new BScroll(this.$refs.menuWrapper, {
        scrollX: false,
        scrollY: true,
        click: true
      })
    })
  },
  methods: {
    ...mapActions(['queryCategoryName', 'queryCategoryData', 'checkUserType', 'getBrandSaleZoneList', 'resetContentIds']),
    /**
     * 点击切换类目
     * @param event 当前标签
     * @param index 元素下标
     * @param categoryId 一级类目Id
     */
    selectMenu(event, index, categoryId, parentLevelName) {
      window.thinkingReport.track('exposure', {
        point_id: '22784',
        page_id: this.pageId,
        tab_name: parentLevelName
      })
      window.thinkingReport.track('click_list', {
        point_id: '21626',
        page_id: this.pageId,
        click_index: index + 1,
        tab_name: parentLevelName
      })
      if (this.categoryId !== categoryId) {
        // 表示点击的非上次操作
        this.clickIndex = index
        this.categoryId = categoryId
        // 查询对应类目下右侧数据
        this.$store.commit('categoryNav/SETPLNAME', parentLevelName)
        // 非新品tab 才走原有逻辑 
        if (this.categoryId != this.newGoodsTabId) {
          const { brandSaleZone, resourceId } = this.menuData[index]
          if (brandSaleZone == 1 && resourceId) {
            try {
              const element = document.querySelector('.brand-view')
              element && element.scrollIntoView()
            } catch (error) {
              console.log(error)
            }

            this.$store.commit('categoryNav/SETRESOURCEID', resourceId)
            this.$store.commit('categoryNav/SETRIGHTMENUTYPE', 3)
            this.$store.commit('categoryNav/SETPAGEINDEX', 0)
            this.resetContentIds()
            this.getBrandSaleZoneList()
          } else {
            this.$store.commit('categoryNav/SETRIGHTMENUTYPE', 1)
            this.queryCategoryData()
          }
        } else {
          this.$store.commit('categoryNav/SETRIGHTMENUTYPE', 2)
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.nav-view{
  flex-shrink: 0;
  width: 1.68rem;
  overflow-y: hidden;
  .menu-list{
    pointer-events: auto;
    margin: 0;
    padding: 0;
    .menu-item{
      position: relative;
      height: 1.24rem;
      line-height: 1.1;
      font-size: 0.28rem;
      color: #808080;
      overflow: hidden;
      text-overflow: ellipsis;
      text-align: center;
      padding-left: 0.24rem;
      padding-right: 0.24rem;
      display: flex;
      justify-content: center;
      align-items: center;
      word-break: break-all;
      &.center{
        text-align: center;
      }
      &.active{
        color: #F10D3B;
        font-weight: 700;
        &::before{
          content: '';
          position:absolute;
          left:0;
          top:0.32rem;
          width:0.06rem;
          height:0.6rem;
          background: url('../img/menu_active.png') no-repeat;
          background-size: cover;
        }
      }
    }
  }
}
</style>
